import { Button } from '@octopus-do/octopus-storybook'
import cx from 'classnames'
import type React from 'react'

import type { TariffPlan } from '@/types'
import css from './pricing.module.scss'
import { getButtonStyle, getButtonText, getVariant } from './utils'

type Props = TariffPlan & {
  planType: string
  planId: string
  loadingId: string | null
  planIndex: number
  types: string[]
  onSubscribeClick: (planId: string, name: string, variant: string) => void
}

interface FeaturesProps {
  features: string[]
  color: string
}

const Features: React.FC<FeaturesProps> = ({ features, color }) => (
  <ul className={css.features}>
    {features.map((feature, index) => (
      <li key={index} className={cx(css.item, css.defaultText)}>
        <i className="fa fa-solid fa-check-circle" style={{ color }} />
        <span>{feature}</span>
      </li>
    ))}
  </ul>
)

export const AgencyPlan: React.FC<Props> = ({
  id,
  name,
  description,
  color,
  price,
  paymentType,
  features,
  additional_features,
  planId,
  planType,
  loadingId,
  planIndex,
  types,
  onSubscribeClick,
}) => (
  <div
    key={id}
    className={cx(css.plan, css.agency)}
    style={{ borderTopColor: color, color }}
  >
    <div className={css.column}>
      <h2 className={css.name}>{name}</h2>
      <p className={cx(css.description, css.defaultText)}>{description}</p>

      <Features features={features} color={color} />
    </div>

    <div className={css.column}>
      <Features features={additional_features} color={color} />
    </div>

    <div className={css.column}>
      <h3 className={css.priceWrap}>
        <span className={css.price}>
          {price[planType as keyof typeof price]}
        </span>
        <span className={css.dollar}>$</span>
      </h3>

      <p className={cx(css.priceDescription, css.defaultText)}>
        {paymentType[planType as keyof typeof paymentType]}
      </p>

      <Button
        className={css.button}
        style={getButtonStyle(color)}
        label={getButtonText(id, planId)}
        loading={id === loadingId}
        disabled={id === planId}
        onClick={() =>
          onSubscribeClick(
            id,
            name,
            getVariant(id, planId, loadingId, planIndex, types)
          )
        }
      />
    </div>
  </div>
)
